export default "__VITE_ASSET__BvvQ5EmU__"